import { render, staticRenderFns } from "./RelatedAccountData.vue?vue&type=template&id=6bd322c0"
import script from "./RelatedAccountData.vue?vue&type=script&lang=js"
export * from "./RelatedAccountData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports